import { baseAPI } from "../baseApi"

export const mapApiSlice = baseAPI.injectEndpoints({
    endpoints: builder => ({
        // запрос на получение координат по известной позиции объекта
        fetchPathPositionCoords: builder.query<any, any>({
            query: (args) => ({
                url: `address/positionToCoords?RoadID=${args.roadId}&PathID=${args.pathId}&Position='${args.position}'`
            })
        }),
        // запрос на получение позиции по известным координатам
        fetchCoordsToPosition: builder.query<any, any>({
            query: ({ pathId, roadId, latitude, longitude }) => ({
                url: `address/coordsToPosition`,
                params: {
                    ...(pathId != null && { PathId: pathId }),
                    ...(roadId != null && { RoadId: roadId }),
                    Latitude: latitude,
                    Longitude: longitude
                }
            })
        })
    })
})

export const {
    useLazyFetchPathPositionCoordsQuery,
    useFetchCoordsToPositionQuery,
} = mapApiSlice